import { createSelector } from 'reselect';
import { containsNewFile } from './helpers';

const getBulkFiles = ({ bulkUploadV2 }) => {
	return bulkUploadV2.bulkFiles;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.selectedAsset;
};

const getUploadingStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.isUploading;
};

const getProcessingStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.isProcessing;
};

const geUploadAllowedStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 &&
		bulkUploadV2.uploadStatus &&
		bulkUploadV2.uploadStatus.data &&
		bulkUploadV2.uploadStatus.data.uploadAllowed &&
		containsNewFile(bulkUploadV2.bulkFiles);
};

const geProcessAllowedStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.processAllowed;
};

const getDateInterval = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.dateInterval;
};

export const getModel = createSelector([
	getBulkFiles,
	getSelectedAsset,
	getUploadingStatus,
	getProcessingStatus,
	geUploadAllowedStatus,
	geProcessAllowedStatus,
	getDateInterval,
], (
	bulkFiles,
	selectedAsset,
	isUploading,
	isProcessing,
	isUploadAllowed,
	isProcessAllowed,
	dateInterval,
) => {
	return {
		bulkFiles,
		selectedAsset,
		isUploading,
		isProcessing,
		isUploadAllowed,
		isProcessAllowed,
		dateInterval,
	};
});
